const BusinessServices = () => {
  const services = [
    {
      image: '/image/businessServices1.jpg',
      alt: 'システムエンジニアリングサービス',
      title: 'システムエンジニアリングサービス - 株式会社MSK',
      heading: 'システムエンジニアリングサービス',
      description: 'お客様のニーズに合わせた最適なシステムエンジニアをご提供します。',
    },
    {
      image: '/image/businessServices2.jpg',
      alt: '受託開発',
      title: '受託開発 - 株式会社MSK',
      heading: '受託開発',
      description: '業務システムからWebアプリケーションまで、幅広い開発を承ります。',
    },
  ];

  return (
    <section id="services" className="py-16 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        {/* セクションタイトル */}
        <div className="text-center mb-16">
          <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
            Our Services
          </p>
          <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
            事業案内
          </h4>
        </div>

        {/* サービスカード */}
        <div className="flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl w-full">
            {services.map((service, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.06)] hover:shadow-[0_8px_32px_rgba(137,181,107,0.18)] transition-all duration-400 hover:-translate-y-1"
              >
                <div className="relative w-full h-48 bg-[#89B56B]/5 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.alt}
                    title={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#89B56B] mb-3">{service.heading}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTAボタン */}
        <div className="text-center mt-12">
          <a
            href="/record"
            className="inline-flex items-center gap-2 px-10 py-3.5 bg-[#89B56B] text-white font-medium rounded-full hover:bg-[#5DAA68] transition-colors duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-[#89B56B]/20"
          >
            開発実績を見る
          </a>
        </div>
      </div>
    </section>
  );
};

export default BusinessServices;